import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled, { css, keyframes } from 'styled-components';
import * as tokens from '@trp-rps-rps-shared-web/rps-shared-web-styles';

interface Props {
  isLoading: boolean;
  initialLoad: boolean;
}

const rotate = keyframes`
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
`;

const Loader = styled.div`
  position: relative;
  text-indent: -9999em;
  border: 2px solid #d6d6d5;
  border-left-color: ${tokens.ColorBrandBrightBlue};
  border-width: 8px;
  margin: 64px auto 32px;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 2.5s infinite linear;
  animation: ${rotate} 2.5s infinite linear;
  border-radius: 50%;
  width: 160px;
  height: 160px;
  @media (max-width: 768px) {
    width: 120px;
    height: 120px;
    border-width: 6px;
  }
`;

const AppLoader = styled.div<{ initialLoad: boolean }>`
  z-index: 1100;
  position: absolute;
  top: 0;
  width: 100%;
  height: 100vh;
  background-color: ${props => (props.initialLoad ? ' #fff' : 'rgba(0,0,0,0.7)')};
  ${(props: any) =>
    !props.initialLoad &&
    css`
      backdrop-filter: blur(8px);
    `}
`;

const LoaderContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 640px;
  min-height: 352px;
  border-radius: 8px;
  // box-shadow: 0 16px 16px 0 rgba(45, 57, 64, 0.06), 0 0 8px 0 rgba(45, 57, 64, 0.06);
  background-color: #ffffff;
  transform: translate(-50%, -50%);
  @media (max-width: 767px) {
    width: calc(100vw - 32px);
  }
`;

const WelcomeText = styled.div`
  font-family: Nimbus Sans Light;
  font-size: 24px;
  font-weight: 300;
  line-height: 32px;
  letter-spacing: -0.5px;
  text-align: center;
  color: #253746;
  padding-bottom: 64px;
  @media (max-width: 768px) {
    font-size: 20px;
    line-height: 26px;
    padding-bottom: 40px;
  }
`;

const TextDiv = styled.div`
  padding-left: 40px;
  padding-right: 40px;
`;

class LoadingSpinner extends Component<Props> {
  componentDidMount() {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
    document.body.style.position = 'fixed';
    document.body.style.width = '100vw';
    document.body.style.height = '100vh';
  }

  componentWillUnmount() {
    document.body.style.position = '';
    document.body.style.width = '';
    document.body.style.height = '';
  }

  render() {
    const { isLoading, initialLoad } = this.props;
    return isLoading ? (
      <AppLoader initialLoad={initialLoad}>
        <LoaderContainer>
          <Loader />
          <WelcomeText>
            {initialLoad ? (
              <div>
                Welcome!
                <br />
                We&#39;re updating your outlook.
              </div>
            ) : (
              <TextDiv>Based on your changes, we&#39;re updating your outlook.</TextDiv>
            )}
          </WelcomeText>
        </LoaderContainer>
      </AppLoader>
    ) : null;
  }
}

export default connect(null)(LoadingSpinner);
